export default function Worker_fn() {
  return new Worker("/dist/8.2.5.129/" + "C2paMp4.vbworker.min.worker.js");
}
